import { render } from "./PricingCard.vue?vue&type=template&id=a0709cb0"
import script from "./PricingCard.vue?vue&type=script&lang=js"
export * from "./PricingCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__